<goab-button
  *ngIf="buttonText && !hideUiElements"
  (onClick)="openModal(getCalloutVariant, $event)"
  [variant]="getButtonVariant"
  [type]="buttonType"
  [disabled]="buttonDisabled"
  [attr.data-cy]="uniqueId + '-dialog-trigger-button'"
  [width]="dialogTriggerButtonWidth"
  [size]="dialogTriggerButtonSize"
  >{{ buttonText }}</goab-button
>

<a
  href="#"
  *ngIf="linkText && !hideUiElements"
  (click)="openModal(calloutVariant, $event)"
  [attr.data-cy]="uniqueId + '-dialog-trigger-link'"
  >{{ linkText }}</a
>

@if (displayContent && !hideUiElements){
<span (click)="openModal(calloutVariant, $event)">
  <ng-content></ng-content>
</span>
}

<goab-modal
  [attr.id]="uniqueId + '-modal-dialog'"
  type="callout"
  [open]="isOpen"
  [calloutVariant]="getText(calloutVariant, dialogContent?.calloutVariant) ?? null"
  [heading]="getText(headerText, dialogContent?.headerText)"
  [closable]="closable"
  (onClose)="closeModal()"
  class="common-dialog"
>
  <div
    *ngIf="getText(bodyText, dialogContent?.bodyText)"
    [innerHTML]="getText(bodyText, dialogContent?.bodyText)"
    class="bodyText dialog-body-wrapper"
  ></div>

  <div *ngIf="!getText(bodyText, dialogContent?.bodyText)" class="bodyText">
    <ng-content select="[body]"></ng-content>
  </div>

  <div slot="actions">
    <goab-button-group alignment="end">
      <!--hidden button will remove default focus on buttons when auto popping dialog. focus seems to always go on the first button element-->
      <!-- <goab-button [hidden]="true"></goab-button> -->
      <goab-button
        *ngIf="okText || dialogContent?.okButtonText"
        (click)="ok()"
        type="primary"
        data-cy="ok-button"
        size="compact"
        >{{ getText(okText, dialogContent?.okButtonText) }}</goab-button
      >
      <goab-button
        *ngIf="cancelText || dialogContent?.cancelButtonText"
        (onClick)="cancel()"
        [type]="cancelButtonType"
        data-cy="cancel-button"
        size="compact"
        >{{ getText(cancelText, dialogContent?.cancelButtonText) }}</goab-button
      >
      <goab-button
        *ngIf="confirmText || dialogContent?.confirmButtonText"
        (onClick)="confirm()"
        type="primary"
        data-cy="confirm-button"
        size="compact"
        [variant]="buttonVariant"
        >{{ getText(confirmText, dialogContent?.confirmButtonText) }}</goab-button
      >
    </goab-button-group>
  </div>
</goab-modal>
